import PrizeFilterOptions from 'prizes/weekly-draw/PrizeFilterOptions';
import Link from 'next/link';
import React from 'react';
import { colors } from 'utils/constants';
import ImageWithFallback from 'components/ImageWithFallback';

const PrizeFilterSelector = ({ selectedFilterId }) => {
  return (
    <div className="bg-gray-100 w-full">
      <div className="filterOptions !mx-auto py-6">
        <img
          src="https://img.spacergif.org/v1/spacer.gif"
          width="1em"
          height="1"
          style={{ width: '1em' }}
        />

        {PrizeFilterOptions.map((filter) => {
          const selected =
            filter.id === selectedFilterId ||
            (!selectedFilterId && !filter.id); /* all prizes */
          return (
            <Link key={filter.id ?? 'NA'} href={filter.href} passHref>
              <div className={'filterOption'}>
                <div className="imageContainer">
                  {selected ? (
                    <ImageWithFallback
                      src={filter.selectedIcon}
                      fallbackSrc={filter.selectedIcon}
                      width="600"
                      height="600"
                    />
                  ) : (
                    <ImageWithFallback
                      src={filter.icon}
                      fallbackSrc={filter.icon}
                      width="600"
                      height="600"
                    />
                  )}

                  {!filter.withoutOverlayEffect && (
                    <img
                      src={filter.selectedIcon}
                      className="overlaySelectedIcon"
                    />
                  )}
                </div>

                <div
                  className={'filterName'}
                  style={{
                    fontWeight: selected ? '800' : '600',
                    textShadow: selected
                      ? `0 0 3px ${colors.brand.neon}`
                      : 'none',
                  }}
                >
                  {filter.name.replace('Trips & Stays', 'Trips')}
                </div>
              </div>
            </Link>
          );
        })}

        <img
          src="https://img.spacergif.org/v1/spacer.gif"
          width="1em"
          height="1"
          style={{ width: '1em' }}
        />

        <style jsx>{`
          .filterOptions {
            display: flex;
            margin: 0;
            width: 100%;
            max-width: 1050px;
            overflow-x: auto;
          }

          .filterOptions::-webkit-scrollbar {
            display: none;
          }

          .filterOption {
            cursor: pointer;
            width: 60px;
            margin: 1em 1em 0;
            flex-grow: 1;
            text-align: center;
            transition: 0.2s;
          }

          @media (max-width: 550px) {
            .filterOptions {
              justify-content: flex-start;
            }
          }

          .imageContainer {
            display: inline-flex;
            position: relative;
            height: 60px;
            width: 60px;
            border-radius: 50%;

            transition: 0.2s;
          }

          @media (min-width: 800px) {
            .imageContainer {
              height: 80px;
              width: 80px;
            }
          }

          .filterIcon,
          .overlaySelectedIcon {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
            transition: 0.2s;
          }

          .overlaySelectedIcon {
            opacity: 0;
            width: 50px;
            height: 50px;
            left: calc(50% - 25px);
            top: calc(50% - 25px);
            object-fit: contain;
          }

          .filterName {
            font-weight: 600;
            transition: 0.2s;
            white-space: nowrap;
            display: flex;
            justify-content: center;
          }

          @media (min-width: 800px) {
            .filterName {
              font-size: 1.1em;
            }
          }

          .filterOption.selected .imageContainer {
            box-shadow: 0 0 3px 2px rgba(0, 255, 221, 0.5);
            transition: 0.2s;
          }

          .filterOption.selected > .imageContainer > .filterIcon {
            -webkit-filter: brightness(50%); /* Safari 6.0 - 9.0 */
            filter: brightness(50%);
            transition: 0.2s;
          }

          .filterOption.selected > .imageContainer > .overlaySelectedIcon {
            opacity: 1;
            transition: 0.2s;
          }

          .filterOption.selected .filterName {
            font-weight: 700;
            text-shadow: 0 0 3px rgba(0, 255, 221, 0.9);
            transition: 0.2s;
          }

          .filterOption.selected {
            transform: scale(1.1);
            transition: 0.2s;
            cursor: default;
          }
        `}</style>
      </div>
    </div>
  );
};

export default PrizeFilterSelector;
